import { render, staticRenderFns } from "./OptionImagePositionSettings.vue?vue&type=template&id=e9844c82&scoped=true"
import script from "./OptionImagePositionSettings.vue?vue&type=script&lang=js"
export * from "./OptionImagePositionSettings.vue?vue&type=script&lang=js"
import style0 from "./OptionImagePositionSettings.vue?vue&type=style&index=0&id=e9844c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9844c82",
  null
  
)

export default component.exports